import { CircularProgress as MUICircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { styledBy } from '../../../utils/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: theme.spacing(2),
        "& .MuiCircularProgress-svg": {
            color: (styledBy('ascent', theme.palette.ascents)),
        }
    },

}));

export default function CircularProgress({ ascent = "primary", ...props }) {
    const classes = useStyles({ ascent });

    return (
        <MUICircularProgress className={classes.root} {...props} />
    );
}
